
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forget",
      function () {
        return require("private-next-pages/forget.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forget"])
      });
    }
  